import { createAction } from '@reduxjs/toolkit';

import { useActionObservableCallback } from '@perpay-web/hooks/useActionObservableCallback';
import { useSteps } from '@perpay-web/hooks/useSteps';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

// EDIT PHONE FLOW STEPS
export const VERIFY_MFA = 'verify-mfa';
export const CHANGE_PHONE = 'change-phone';
export const VERIFY_PHONE = 'verify-phone';

export const EDIT_PHONE_STEPS = [VERIFY_MFA, CHANGE_PHONE, VERIFY_PHONE];

export const EDIT_PHONE_STEPS_TO_NUMBERS_MAP = {
    [VERIFY_MFA]: 1,
    [CHANGE_PHONE]: 2,
    [VERIFY_PHONE]: 3,
};

// EDIT PHONE FLOW ACTIONS
export const editPhoneSetSteps = createAction('EDIT_PHONE_STEPS::SET_STEP');
export const editPhoneGoBack = createAction('EDIT_PHONE_STEPS::GO_BACK');

const useEditPhone = () => {
    const steps = useSteps(EDIT_PHONE_STEPS, VERIFY_MFA);

    useActionObservableCallback(hookAction$, editPhoneSetSteps().type, (step) =>
        steps.setStep(step),
    );

    useActionObservableCallback(hookAction$, editPhoneGoBack().type, () =>
        steps.goBack(),
    );

    return {
        ...steps,
    };
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useEditPhone();

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [EditPhoneProvider, useEditPhoneContext] =
    createContextProvider(providerFactory);
